// extracted by mini-css-extract-plugin
export var desc = "style-module--desc--c5f55";
export var mt = "style-module--mt--0e1a1";
export var title = "style-module--title--0a456";